"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectIcon = void 0;
var react_1 = __importStar(require("react"));
var icon_1 = require("../icon/icon");
var providers_1 = require("../../providers");
var brand_config_1 = require("../../configs/brand.config");
var icon_enum_1 = require("../../shared/enums/icon.enum");
var enums_1 = require("../../shared/enums");
function SubjectIcon(props) {
    // retrieve the brand context and throw an error if not available
    var brandState = (0, react_1.useContext)(providers_1.BrandContext);
    if (!brandState) {
        brandState = (0, providers_1.getBrandState)(enums_1.BrandEnum.MONARCH);
    }
    // get the brand subject color from the brand configs
    var brandSubjectColor = brand_config_1.brandConfig[brandState.brand].subject[props.subject];
    // define some default sx
    var defaultSx = {
        color: 'common.white',
        display: 'inline-flex',
        borderRadius: '4px',
        p: '0.25em',
        backgroundColor: brandSubjectColor,
    };
    return (react_1.default.createElement(icon_1.Icon, { icon: icon_enum_1.IconEnum[props.subject],
        size: props.size,
        className: props.className + ' svg-inline--fa',
        sx: __assign(__assign({}, defaultSx), props.sx),
        children: props.children,
        dataTestId: props.dataTestId }));
}
exports.SubjectIcon = SubjectIcon;
